import User from '@/models/user';
import Api from '@/services/api';

class UserApi {
    getCurrentUser(onSuccess: (user: User) => void) {
        return Api.callApi({ url: `/api/v1/user`, onSuccess });
    }
}

export default new UserApi();